import React, { useEffect, useState } from "react";
import theme from "./theme";
import { BrowserRouter, Route, Redirect, Switch, Link } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/store";
import { ThemeProvider } from "styled-components";
import GlobalStyles from "./global-styles";
import GlobalFonts from './fonts/fonts';

import { 
  CompanyContainer, 
  ContactContainer,
  LandingFashionContainer, 
  LandingCPGContainer,
  LandingInteriorContainer,
  LandingRealEstateContainer, 
  LandingGenericContainer,
  FullRealityContainer,
  ProductsContainer,
  Products3dCommerceContainer,
  ProductsVirtualShowroomContainer,
  ProductsStoreInStoreContainer,
  ProductsRetailStoreContainer,
  ProductsVCommerceContainer,
  BookDemoContainer,
  NewHome,
  NewsIndexContainer,
  NewsSingleContainer,
  LandingNike,
  NewsCategoryContainer,
  InvestorsContainer,
  TechContainer,
  CareersContainer,
  CareersDetailContainer,
  ShelfzoneContainer,
  LandingWebinar,
  ThankYouWebinarContainer,
  ExperienceCommerceContainer,
  ExperienceConfiguratorContainer,
  ExperienceLeafeOne,
  ExperienceLeafeTwo,
  ExperienceLeafeThree,
  ExperienceLeafeFour,
  AdvisorsContainer
} from "./containers";

import { Header } from "./components";
import { Footer } from "./components";
import { Cursor } from "./components";


const App = () => {
  document.body.onmousemove = function(e) {
    document.documentElement.style.setProperty('--x', (e.clientX+window.scrollX) + 'px');
    document.documentElement.style.setProperty('--y', (e.clientY+window.scrollY) + 'px');
  }
  
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <GlobalFonts />
        <GlobalStyles />
        <React.Fragment>
          
          <Cursor />
            <section>
              <BrowserRouter basename={"/"}>
              <Header />
                <Switch>
                  <Route
                    path={"/"}
                    exact
                    component={(props) => <NewHome {...props} />}
                  />
                  <Route
                    path={"/invrsion-for-nike"}
                    exact
                    component={(props) => <LandingNike {...props} />}
                  />
                  <Route
                    path={"/company"}
                    exact
                    component={(props) => <CompanyContainer {...props} />}
                  />
                  <Route
                    path={"/industries/fashion"}
                    exact
                    component={(props) => <LandingFashionContainer {...props} />}
                  />
                  <Route
                    path={"/industries/cpg"}
                    exact
                    component={(props) => <LandingCPGContainer {...props} />}
                  />
                  <Route
                    path={"/industries/interior-design"}
                    exact
                    component={(props) => <LandingInteriorContainer {...props} />}
                  />
                  <Route
                    path={"/industries/real-estate"}
                    exact
                    component={(props) => <LandingRealEstateContainer {...props} />}
                  />
                  <Route
                    path={"/industries/generic"}
                    exact
                    component={(props) => <LandingGenericContainer {...props} />}
                  />
                  <Route
                    path={"/full-reality"}
                    exact
                    component={(props) => <FullRealityContainer {...props} />}
                  />
                  <Route
                    path={"/products/index"}
                    exact
                    component={(props) => <ProductsContainer {...props} /> }
                  />
                  <Route
                    path={"/3d-e-commerce"}
                    exact
                    component={(props) => <Products3dCommerceContainer {...props} /> }
                  />
                  <Route
                    path={"/virtual-showroom"}
                    exact
                    component={(props) => <ProductsVirtualShowroomContainer {...props} /> }
                  />
                  <Route
                    path={"/products/store-in-store"}
                    exact
                    component={(props) => <ProductsStoreInStoreContainer {...props} /> }
                  />
                  <Route
                    path={"/products/retail-store-virtualization"}
                    exact
                    component={(props) => <ProductsRetailStoreContainer {...props} /> }
                  />
                  <Route
                    path={"/products/v-commerce"}
                    exact
                    component={(props) => <ProductsVCommerceContainer {...props} /> }
                  />
                  <Route
                    path={"/reach-out"}
                    exact
                    component={(props) => <ContactContainer {...props} /> }
                  />
                  <Route
                    path={"/contact-us"}
                    exact
                    component={(props) => <BookDemoContainer {...props} /> }
                  />
                  <Route  
                    path={"/news"}
                    exact
                    component={(props) => <NewsIndexContainer {...props} /> }
                  />
                 
                  <Route  
                    path={"/investors"}
                    exact
                    component={(props) => <InvestorsContainer {...props} /> }
                  />
                  <Route  
                    path={"/tech"}
                    exact
                    component={(props) => <TechContainer {...props} /> }
                  />
                  <Route  
                    path={"/news/:slug"}
                    exact
                    component={(props) => <NewsSingleContainer {...props} /> }
                  />
                  <Route
                    path={"/news/category/:slug"}
                    exact
                    component={(props) => <NewsCategoryContainer {...props} /> }
                  />
                  <Route  
                    path={"/careers"}
                    exact
                    component={(props) => <CareersContainer {...props} /> }
                  />
                  <Route  
                    path={"/careers/thank-you"}
                    exact
                    component={(props) => <ThankYouWebinarContainer {...props} title="Thanks for your interest!" paragraph="We will be contacting you as soon as possible about your application." noCta={true} /> } 
                  />
                  <Route  
                    path={"/careers/:job"}
                    exact
                    component={(props) => <CareersDetailContainer {...props} /> }
                  />
                  <Route  
                    path={"/shelfzone"}
                    exact
                    component={(props) => <ShelfzoneContainer {...props} /> }
                  />
                  <Route
                    path={"/3d-commerce-webinar"}
                    exact
                    component={(props) => <LandingWebinar {...props} /> }
                  />
                  <Route
                    path={"/3d-commerce-webinar/thank-you"}
                    exact
                    component={(props) => <ThankYouWebinarContainer {...props} title="Thank you for your registration!" paragraph="You will receive a more detailed email a few days before the webinar. Please, don't forget to check your spam ;)" /> }
                  />
                  <Route
                    path={"/3d-commerce/thank-you"}
                    exact
                    component={(props) => <ThankYouWebinarContainer {...props} title="Thanks for your interest!" paragraph="You will be updated about the 3D Commerce news. In case you can’t find it in your inbox, try checking your spam folder." noCta={true} /> }
                  />
                  <Route
                    path={"/3d-commerce-experience"}
                    exact
                    component={(props) => <ExperienceCommerceContainer {...props} isTestPage={false}  /> }
                  />
                  <Route
                    path={"/3d-commerce-experience/configurator"}
                    exact
                    component={(props) => <ExperienceConfiguratorContainer {...props}  /> }
                  />
                  <Route
                    path={"/3d-commerce-experience/item-1"}
                    exact
                    component={(props) => <ExperienceLeafeOne {...props}  /> }
                  />
                  <Route
                    path={"/3d-commerce-experience/item-2"}
                    exact
                    component={(props) => <ExperienceLeafeTwo {...props}  /> }
                  />
                  <Route
                    path={"/3d-commerce-experience/item-3"}
                    exact
                    component={(props) => <ExperienceLeafeThree {...props}  /> }
                  />
                  <Route
                    path={"/3d-commerce-experience/item-4"}
                    exact
                    component={(props) => <ExperienceLeafeFour {...props}  /> }
                  />
                   <Route
                    path={"/advisors"}
                    exact
                    component={(props) => <AdvisorsContainer {...props}  /> }
                  />
                   <Route
                    path={"/test_3Dadv"}
                    exact
                    component={(props) => <ExperienceCommerceContainer {...props} isTestPage={true} /> }
                  />
                  <Route render={() => <Redirect to="/" />} />
                </Switch>
                <Footer />
              </BrowserRouter>
              
            </section>
        </React.Fragment>
      </ThemeProvider>
    </Provider>
  );
};

export default App;
